import { MessageCircle } from "lucide-react";

export type VoContactConsultantBarProps = {
  /** When set, clicking opens the existing contact channel (WhatsApp / mailto). */
  contactHref?: string | null;
};

/**
 * Full-width consultant contact bar — shared on Link A and Link B under the approval panel.
 * Matches the VO document content width (parent `max-w-3xl` container).
 */
export default function VoContactConsultantBar({ contactHref = null }: VoContactConsultantBarProps) {
  const href = String(contactHref ?? "").trim() || null;
  const className =
    "flex w-full min-h-11 items-center justify-center gap-2 rounded-xl border border-[#1A2744]/12 bg-[#FAFAF7] px-4 py-3 text-sm font-medium text-[#1A2744] transition-colors hover:bg-[#F7F5F0]";

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        data-testid="vo-contact-consultant-bar"
      >
        <MessageCircle className="h-4 w-4 shrink-0 text-[#C8A96A]" aria-hidden />
        Contact your Clarity Consultant
      </a>
    );
  }

  return (
    <div className={className} data-testid="vo-contact-consultant-bar" role="note">
      <MessageCircle className="h-4 w-4 shrink-0 text-[#C8A96A]" aria-hidden />
      Contact your Clarity Consultant
    </div>
  );
}
